<template>
  <div class="alert alert-bold fade show" role="alert" :class="variantClass">
    <div class="alert-icon" v-if="isSuccess">
      <i class="flaticon2-check-mark"></i>
    </div>
    <div class="alert-text">
      <slot />
    </div>
    <div class="alert-close">
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">
          <i class="la la-close"></i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: null,
    },
  },

  computed: {
    isSuccess() {
      return this.variant === "success";
    },

    variantClass() {
      return `alert-solid-${this.variant}`;
    },
  },
};
</script>
